import { render, staticRenderFns } from "./EmptyFileBorderIcon.vue?vue&type=template&id=0e5694fa&"
import script from "./EmptyFileBorderIcon.vue?vue&type=script&lang=js&"
export * from "./EmptyFileBorderIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports